import React, { useEffect, useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../App';
import api from '../api';
import DataTable from '../components/DataTable';

const SONUC_RENK = { BEKLEMEDE:'#e65100', INCELENIYOR:'#1565c0', SONUCLANDI:'#1b5e20', KAPATILDI:'#555', YETKISIZ:'#888' };
const KAYNAK = { VATANDAS:'Vatandaş', DIGER_KURUM:'Diğer Kurum', BASIN:'Basın', RESEN:'Re\'sen', IHBAR_HATTI:'İhbar Hattı' };
const KONULAR = ['GURULTU','CEVRE_KIRLILIGI','RUHSATSIZ','KAPASITE_ASIMI','CALISMA_SAATI','HIJYEN','GUVENLIK','YANGIN','DIGER'];

export default function SikayetListesi() {
  const { kullanici } = useContext(AuthContext);
  const navigate = useNavigate();
  const [veriler, setVeriler] = useState([]);
  const [toplam, setToplam] = useState(0);
  const [yukleniyor, setYukleniyor] = useState(false);
  const [modalAcik, setModalAcik] = useState(false);
  const [secili, setSecili] = useState(null);
  const [filtre, setFiltre] = useState({ sonuc: '', q: '' });
  const [form, setForm] = useState({ ruhsat_id:'', basvuru_sahibi:'', basvuru_sahibi_tel:'', anonim:false, sikayet_kaynagi:'VATANDAS', sikayet_konusu:'', sikayet_aciklama:'', sikayet_tarihi:new Date().toISOString().split('T')[0] });
  const [ruhsatArama, setRuhsatArama] = useState('');
  const [ruhsatSonuc, setRuhsatSonuc] = useState([]);
  const yazabilir = ['admin','mudur','personel'].includes(kullanici?.rol);

  useEffect(() => { yukle(); }, [filtre]); // eslint-disable-line

  const yukle = async () => {
    setYukleniyor(true);
    try {
      const p = new URLSearchParams({ ...filtre, limit: 200 });
      const r = await api.get(`/sikayet?${p}`);
      setVeriler(r.data.veriler || []); setToplam(r.data.toplam || 0);
    } finally { setYukleniyor(false); }
  };

  const ruhsatAra = async () => {
    if (!ruhsatArama) return;
    const r = await api.get(`/ruhsat?q=${ruhsatArama}&limit=10`);
    setRuhsatSonuc(r.data.veriler || []);
  };

  const kaydet = async (e) => {
    e.preventDefault();
    try {
      await api.post('/sikayet', form);
      yukle(); setModalAcik(false); setForm({ ruhsat_id:'', basvuru_sahibi:'', basvuru_sahibi_tel:'', anonim:false, sikayet_kaynagi:'VATANDAS', sikayet_konusu:'', sikayet_aciklama:'', sikayet_tarihi:new Date().toISOString().split('T')[0] });
      setRuhsatArama(''); setRuhsatSonuc([]);
    } catch (err) { alert(err.response?.data?.hata || 'Hata'); }
  };

  const sonucKaydet = async (e) => {
    e.preventDefault();
    try {
      await api.put(`/sikayet/${secili.id}`, secili);
      yukle(); setSecili(null);
    } catch (err) { alert(err.response?.data?.hata || 'Hata'); }
  };

  const fmt = d => d ? new Date(d).toLocaleDateString('tr-TR') : '';

  const columns = [
    { key:'sikayet_no', label:'Şikayet No', width:'120px', render: v => <strong style={{fontFamily:'monospace', color:'#1a237e'}}>{v}</strong> },
    { key:'sikayet_tarihi', label:'Tarih', width:'90px', render: v => <span style={{fontSize:'12px'}}>{fmt(v)}</span>, exportValue: r => fmt(r.sikayet_tarihi) },
    { key:'unvan', label:'İşyeri', render: (v,r) => v ? <span style={{fontSize:'12px'}}><strong>{v}</strong> <span style={{color:'#888'}}>({r.rn})</span></span> : <span style={{color:'#999', fontSize:'12px'}}>Ruhsatsız / Belirsiz</span>, exportValue: r => r.unvan || '' },
    { key:'sikayet_konusu', label:'Konu', width:'120px', render: v => <span style={{fontSize:'11px', padding:'2px 8px', borderRadius:'10px', background:'#fff3e0', color:'#e65100'}}>{v?.replace(/_/g,' ')}</span> },
    { key:'sikayet_kaynagi', label:'Kaynak', width:'100px', render: v => <span style={{fontSize:'11px'}}>{KAYNAK[v]||v}</span>, exportValue: r => KAYNAK[r.sikayet_kaynagi]||r.sikayet_kaynagi },
    { key:'basvuru_sahibi', label:'Başvuru Sahibi', render: (v,r) => r.anonim ? <span style={{color:'#999', fontStyle:'italic', fontSize:'12px'}}>Anonim</span> : <span style={{fontSize:'12px'}}>{v||'—'}</span> },
    { key:'atanan_adi', label:'Atanan', width:'110px', render: v => <span style={{fontSize:'12px'}}>{v||'—'}</span> },
    { key:'sonuc', label:'Sonuç', width:'110px', render: v => <span style={{fontSize:'11px', fontWeight:'700', color:SONUC_RENK[v]||'#555'}}>{v?.replace(/_/g,' ')}</span> },
    { key:'_islem', label:'İşlem', width:'130px', sortable:false, filterable:false,
      render:(_,r) => (
        <div style={{display:'flex',gap:'4px'}}>
          <button className="btn btn-outline btn-xs" onClick={e=>{e.stopPropagation();setSecili({...r});}} >Güncelle</button>
          {r.ruhsat_id && <button className="btn btn-secondary btn-xs" onClick={e=>{e.stopPropagation();navigate(`/ruhsat/${r.ruhsat_id}`);}}>Ruhsat</button>}
        </div>
      )
    },
  ];

  return (
    <div>
      <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:'20px'}}>
        <div>
          <h2 style={{color:'#1a237e',fontSize:'20px'}}>⚠️ Şikayet / İhbar Kayıtları</h2>
          <div style={{fontSize:'12px',color:'#888',marginTop:'2px'}}>Dayanak: 3572 s.K. / İşyeri Ruhsat Yönetmeliği Md.33-35</div>
        </div>
        {yazabilir && <button className="btn btn-primary" onClick={() => setModalAcik(true)}>➕ Yeni Şikayet</button>}
      </div>

      <div className="card">
        <div className="search-bar">
          <input className="search-input" placeholder="🔍 Şikayet no, işyeri, konu..." value={filtre.q} onChange={e=>setFiltre({...filtre,q:e.target.value})} />
          <select value={filtre.sonuc} onChange={e=>setFiltre({...filtre,sonuc:e.target.value})} style={{padding:'8px 12px',border:'1px solid #ddd',borderRadius:'4px'}}>
            <option value="">Tüm Durumlar</option>
            {Object.keys(SONUC_RENK).map(k=><option key={k} value={k}>{k.replace(/_/g,' ')}</option>)}
          </select>
        </div>
        <div style={{marginBottom:'8px',fontSize:'12px',color:'#666'}}>Toplam: <strong>{toplam}</strong> şikayet</div>
        <DataTable columns={columns} data={veriler} filename="sikayetler" pdfTitle="Şikayet Kayıtları" loading={yukleniyor} />
      </div>

      {/* Yeni şikayet modal */}
      {modalAcik && (
        <div className="modal-overlay" onClick={e=>e.target===e.currentTarget&&setModalAcik(false)}>
          <div className="modal" style={{maxWidth:'560px'}}>
            <div className="modal-header"><span className="modal-title">Yeni Şikayet / İhbar Kaydı</span><button className="modal-close" onClick={()=>setModalAcik(false)}>×</button></div>
            <form onSubmit={kaydet}>
              <div className="form-grid">
                <div className="form-group" style={{gridColumn:'1/-1'}}>
                  <label>İlgili İşyeri (varsa)</label>
                  <div style={{display:'flex',gap:'8px'}}>
                    <input value={ruhsatArama} onChange={e=>setRuhsatArama(e.target.value)} placeholder="Ruhsat no veya işyeri adı..." className="search-input" onKeyDown={e=>e.key==='Enter'&&(e.preventDefault(),ruhsatAra())} />
                    <button type="button" className="btn btn-outline" onClick={ruhsatAra}>Ara</button>
                  </div>
                  {ruhsatSonuc.length>0 && (
                    <div style={{border:'1px solid #ddd',borderRadius:'4px',marginTop:'4px',maxHeight:'150px',overflowY:'auto',background:'#fff'}}>
                      {ruhsatSonuc.map(r=>(
                        <div key={r.id} onClick={()=>{setForm(f=>({...f,ruhsat_id:r.id}));setRuhsatArama(`${r.rn} - ${r.unvan}`);setRuhsatSonuc([]);}}
                          style={{padding:'8px 12px',cursor:'pointer',borderBottom:'1px solid #f0f0f0',fontSize:'13px'}}
                          onMouseOver={e=>e.currentTarget.style.background='#f5f5ff'} onMouseOut={e=>e.currentTarget.style.background='#fff'}>
                          <strong>{r.rn}</strong> — {r.unvan}
                        </div>
                      ))}
                    </div>
                  )}
                  {form.ruhsat_id && <div style={{fontSize:'12px',color:'#1b5e20',marginTop:'4px'}}>✅ Seçildi (ID: {form.ruhsat_id}) <button type="button" style={{color:'#c62828',background:'none',border:'none',cursor:'pointer'}} onClick={()=>{setForm(f=>({...f,ruhsat_id:''}));setRuhsatArama('');}}>✕</button></div>}
                </div>
                <div className="form-group">
                  <label>Kaynak *</label>
                  <select value={form.sikayet_kaynagi} onChange={e=>setForm({...form,sikayet_kaynagi:e.target.value})} required>
                    {Object.entries(KAYNAK).map(([k,v])=><option key={k} value={k}>{v}</option>)}
                  </select>
                </div>
                <div className="form-group">
                  <label>Konu *</label>
                  <select value={form.sikayet_konusu} onChange={e=>setForm({...form,sikayet_konusu:e.target.value})} required>
                    <option value="">Seçin...</option>
                    {KONULAR.map(k=><option key={k} value={k}>{k.replace(/_/g,' ')}</option>)}
                  </select>
                </div>
                <div className="form-group">
                  <label>Tarih</label>
                  <input type="date" value={form.sikayet_tarihi} onChange={e=>setForm({...form,sikayet_tarihi:e.target.value})} />
                </div>
                <div className="form-group" style={{display:'flex',alignItems:'center',gap:'8px',paddingTop:'22px'}}>
                  <input type="checkbox" id="anonim" checked={form.anonim} onChange={e=>setForm({...form,anonim:e.target.checked})} />
                  <label htmlFor="anonim" style={{marginBottom:0}}>Anonim Şikayet</label>
                </div>
                {!form.anonim && <>
                  <div className="form-group"><label>Başvuru Sahibi Adı</label><input value={form.basvuru_sahibi} onChange={e=>setForm({...form,basvuru_sahibi:e.target.value})} /></div>
                  <div className="form-group"><label>Telefon</label><input value={form.basvuru_sahibi_tel} onChange={e=>setForm({...form,basvuru_sahibi_tel:e.target.value})} /></div>
                </>}
                <div className="form-group" style={{gridColumn:'1/-1'}}><label>Şikayet Açıklaması</label><textarea value={form.sikayet_aciklama} onChange={e=>setForm({...form,sikayet_aciklama:e.target.value})} rows={3} /></div>
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-secondary" onClick={()=>setModalAcik(false)}>İptal</button>
                <button type="submit" className="btn btn-primary">Kaydet</button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Sonuç güncelle modal */}
      {secili && (
        <div className="modal-overlay" onClick={e=>e.target===e.currentTarget&&setSecili(null)}>
          <div className="modal" style={{maxWidth:'500px'}}>
            <div className="modal-header"><span className="modal-title">Şikayet Güncelle — {secili.sikayet_no}</span><button className="modal-close" onClick={()=>setSecili(null)}>×</button></div>
            <form onSubmit={sonucKaydet}>
              <div className="form-grid">
                <div className="form-group"><label>Durum *</label>
                  <select value={secili.sonuc} onChange={e=>setSecili({...secili,sonuc:e.target.value})} required>
                    {Object.keys(SONUC_RENK).map(k=><option key={k} value={k}>{k.replace(/_/g,' ')}</option>)}
                  </select>
                </div>
                <div className="form-group">
                  <label>Denetim Yapıldı mı?</label>
                  <select value={secili.denetim_yapildi?'true':'false'} onChange={e=>setSecili({...secili,denetim_yapildi:e.target.value==='true'})}>
                    <option value="false">Hayır</option><option value="true">Evet</option>
                  </select>
                </div>
                {secili.denetim_yapildi && <div className="form-group"><label>Denetim Tarihi</label><input type="date" value={secili.denetim_tarihi||''} onChange={e=>setSecili({...secili,denetim_tarihi:e.target.value})} /></div>}
                <div className="form-group" style={{gridColumn:'1/-1'}}><label>Sonuç Açıklaması</label><textarea value={secili.sonuc_aciklama||''} onChange={e=>setSecili({...secili,sonuc_aciklama:e.target.value})} rows={3} /></div>
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-secondary" onClick={()=>setSecili(null)}>İptal</button>
                <button type="submit" className="btn btn-primary">Güncelle</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}
